import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';

/**
 * Leaves out options marked `retired` (providers tagged "Do not use for new bookings", #248), except the one that is
 * selected: an arrangement that already uses a retired provider still shows it.
 */
@Pipe({
  name: 'withoutRetired',
})
export class WithoutRetiredPipe implements PipeTransform {
  transform<T>(options: T[] | null | undefined, selected?: any, dataKey?: string): T[] {
    if (!Array.isArray(options)) return options as any;
    if (!options.some((o: any) => o?.retired === true)) return options;
    const isSelected = (o: any) =>
      selected !== null && selected !== undefined && (o === selected || (dataKey ? _.get(o, dataKey) === _.get(selected, dataKey) && _.get(o, dataKey) !== undefined : _.isEqual(o, selected)));
    return options.filter((o: any) => o?.retired !== true || isSelected(o));
  }
}
